import {
    CLEAR_MERCHANT_INFO,
    GET_DENOMINATION_LIST,
    GET_MERCHANT_INFO,
    GET_MERCHANT_LIST,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    merchantList: [],
    merchantInfo: {},
    denominations: [],
};

const merchantReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_MERCHANT_LIST: {
            return {
                ...state,
                merchantList: action.merchantList,
            };
        }
        case GET_MERCHANT_INFO: {
            return {
                ...state,
                merchantInfo: action.merchant,
            };
        }
        case GET_DENOMINATION_LIST: {
            return {
                ...state,
                denominations: action.denominations,
            };
        }
        case CLEAR_MERCHANT_INFO: {
            return {
                ...state,
                merchantInfo: {},
                denominations: [],
            };
        }
        default: {
            return state;
        }
    }
};

export default merchantReducer;
